export default __webpack_public_path__ + "static/media/blog-3.3b954398.png";